import axios from "axios";
import store from "@/store/index";
import cleanParams from "./cleanParams";

const URL = window.location;

const axiosV1 = axios.create({
    baseURL: `${URL.protocol}//${URL.hostname}/v1/`
});

// REQUEST INTERCEPTOR
axiosV1.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("auth_token");

        // Ensure headers always exist
        config.headers = {
            ...config.headers,
        };

        config.params = cleanParams(config.params);

        // Add Authorization header only if token is available
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// RESPONSE INTERCEPTOR
axiosV1.interceptors.response.use(
    (response) => {
        store.commit("alert/setAutoClose", false);
        store.commit("alert/setAutoClose", true);
        return response;
    },
    (error) => {
        store.commit("alert/setAutoClose", false);

        const status = error?.response?.status;
        const responseMessage = error?.response?.data?.message;
        const responseError = error?.response?.data?.error;

        if (![200, 202].includes(status)) {

            if (responseMessage) {
                store.commit("alert/error", responseMessage);
            } else if (responseError) {
                store.commit("alert/error", responseError);
            } else {
                console.warn(error);
            }
        }

        store.commit("alert/setAutoClose", true);

        return Promise.reject(error);
    }
);

export default axiosV1;
